module.exports = __webpack_public_path__ + "img/nodules.ef4daf10.svg";